import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import type { MRT_DisplayColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  booleanCellValues,
  calcLineaNameContrato,
  emptyCellOneLevel,
  formatCurrencyCell,
} from '@/shared';
import { CustomTableLink, SingleButton } from '@/shared/components/ui';
import { Contrato } from '@/shared/interfaces';
import { ContractStateChip, DataContractStateChip } from '../components';
import InfoUser from '@/shared/components/ui/InfoUser/InfoUser';
import dayjs from 'dayjs';

export const useColumnsClientes = () => {

  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.clientes.fibraOpticaNav;

  ///* basic -----------------------
  const base01 = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'Identificación',
        size: 60,
        Cell: ({ row }) =>
        {

          return row.original?.cliente_data?.identificacion

          /* row.original?.cliente_data?.identificacion ? (
            <>
              <CustomTableLink
                url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
                text={row.original?.cliente_data?.identificacion}
              />
            </>
          ) : (
            'N/A'
          ), */
        }
      },
      {
        accessorKey: 'razon_social',
        header: 'Nombre',
        size: 333,
        Cell: ({ row }) => {
          const calculatedName = calcLineaNameContrato(row?.original! || {});


          return calculatedName

          /* return row.original?.cliente_data?.razon_social ? (
            <CustomTableLink
              url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
              text={calculatedName}
            />
          ) : (
            'N/A'
          ); */
        },
      },


      // estado de información ------------------
      {
        accessorKey: 'estado_actualizacion',
        header: 'Estado Contrato',
        enableColumnFilter: false,
        size: 250,
        Cell: ({ row }) => {
          return <DataContractStateChip statusData={row.original?.estado_actualizacion!} />;
        },
      },
      // estado servicio ------------------
      {
        accessorKey: 'estado_servicio',
        header: 'Estado Servicio',
        enableColumnFilter: false,
        size: 222,
        Cell: ({ row }) => {
          return <ContractStateChip contract={row.original} />;
        },
      },


      // contrato ------------------
      {
        accessorKey: 'numero_referencia',
        header: 'Núm. Contrato',
        size: 90,
        Cell: ({ row }) => emptyCellOneLevel(row, 'numero_referencia'),
      },
      {
        accessorKey: 'url_contrato',
        header: 'CONTRATO',
        size: 90,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const url = row.original?.url_contrato;
          if (!url) return 'N/A';

          return (
            <SingleButton
              newCustomButton
              iconButton
              label="Ver contrato"
              color="error"
              startIcon={<PictureAsPdfIcon />}
              onClick={() => {
                window.open(url, '_blank');
              }}
            />
          );
        },
      },


    ],
    []
  );

  const clientDetails = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
        enableColumnFilter: false,
        Cell: ({ row }) => row.original?.cliente_data?.direccion || 'N/A',
      },
      {
        accessorKey: 'es_tercera_edad',
        header: 'Tercera Edad',
        size: 300,
        enableColumnFilter: false,
        Cell: ({ row }) => row.original?.cliente_data?.es_tercera_edad ? "SI" : "NO",
      },
      {
        accessorKey: 'celular',
        header: 'CELULAR',
        size: 180,
        enableColumnFilter: false,
        Cell: ({ row }) => row.original?.cliente_data?.celular || 'N/A',
      },
      {
        accessorKey: 'celular_2',
        header: 'CELULAR 2',
        size: 180,
        enableColumnFilter: false,
        Cell: ({ row }) => row.original?.cliente_data?.celular_2 || 'N/A',
      },
      {
        accessorKey: 'email',
        header: 'EMAIL',
        size: 180,
        enableColumnFilter: false,
        Cell: ({ row }) => row.original?.cliente_data?.email || 'N/A',
      },

      // TODO: persona ref and another fields included in preagendamiento table
    ],
    []
  );

  const serviceDetails01 = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      ///* fk ========================================
      // // plan ------------------
      {
        accessorKey: 'tipo_plan',
        header: 'Tipo Plan',
        size: 210,
        Cell: ({ row }) => {
          return emptyCellOneLevel(row, 'tipo_plan');
        },
      },
      {
        accessorKey: 'tipo_servicio',
        header: 'Tipo de servicio',
        size: 210,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          return emptyCellOneLevel(row, 'tipo_servicio');
        },
      },
      {
        accessorKey: 'plan',
        header: 'Plan de internet',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || 'N/A';
        },
      },
      {
        accessorKey: 'velocidad_plan',
        header: 'Velocidad de internet',
        size: 210,
        Cell: ({ row }) => {
          return row.original?.velocidad
            ? `${row.original?.velocidad} ${row.original?.plan_data?.unidad || ''
            }`
            : 'N/A';
        },
      },
      {
        accessorKey: 'valor_plan',
        header: 'Valor del plan',
        enableColumnFilter: false,
        size: 210,
        Cell: ({ row }) => {
          return formatCurrencyCell(row, 'valor_plan');
        },
      },

      // valor_instalacion ------------------
      {
        accessorKey: 'valor_instalacion',
        header: 'Valor Instalación',
        enableColumnFilter: false,
        size: 210,
        Cell: ({ row }) => {
          return formatCurrencyCell(row, 'valor_instalacion');
        },
      },
      {
        accessorKey: 'valor_instalacion_iva',
        header: 'Valor IVA Instalación',
        enableColumnFilter: false,
        size: 210,
        Cell: ({ row }) => {
          return formatCurrencyCell(row, 'valor_instalacion_iva');
        },
      },
      {
        accessorKey: 'valor_instalacion_total',
        header: 'Valor Total Instalación',
        enableColumnFilter: false,
        size: 210,
        Cell: ({ row }) => {
          return formatCurrencyCell(row, 'valor_instalacion_total');
        },
      },

      // flota & nap ------------------
      // {
      //   accessorKey: 'flota',
      //   header: 'FLOTA',
      //   size: 180,
      //   Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      // },
      // {
      //   accessorKey: 'nap_nombre',
      //   header: 'NAP',
      //   size: 180,
      //   Cell: ({ row }) => row.original?.nap_data?.nombre || 'N/A',
      // },
      // {
      //   accessorKey: 'distancia',
      //   header: 'DISTANCIA A LA NAP',
      //   enableColumnFilter: false,
      //   size: 180,
      //   Cell: ({ row }) => `${row.original?.orden_trabajo_data?.distancia} metros` || 'N/A',//emptyCellOneLevel(row, 'distancia'),
      // },
    ],
    []
  );

  const activacionDetails = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'ipv4_actual',
        header: 'IP Actual',
      },
      {
        accessorKey: 'pppoe',
        header: 'PPPoE',
      },

      // {
      //   accessorKey: 'ipv_4_actual',
      //   header: 'Dirección IP',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
      //   Cell: ({ row }) => row.original?.orden_trabajo_data?.ipv4_actual || 'N/A',//emptyCellOneLevel(row, 'ipv_4_actual'),
      // },
      // {
      //   accessorKey: 'pppoe',
      //   header: 'PPPoE',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //   Cell: ({ row }) => row.original?.orden_trabajo_data?.pppoe || 'N/A',//emptyCellOneLevel(row, 'pppoe'),
      // },
      // {
      //   accessorKey: 'pppassword',
      //   header: 'PPPassword',
      //   enableColumnFilter: false,
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //   Cell: ({ row }) => emptyCellOneLevel(row, 'pppassword'),
      // },

      {
        accessorKey: 'es_router_ac',
        header: 'Tiene Router AC',
        enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => booleanCellValues(row, 'es_router_ac'),
      },
      // {
      //   accessorKey: 'serie_ont',
      //   header: 'Serie ONT',
      //   enableColumnFilter: false,
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
      //   Cell: ({ row }) => row.original?.orden_trabajo_data?.serie_ont || 'N/A',
      //   //emptyCellOneLevel(row, 'serie_ont'),
      // },
    ],
    []
  );

  const ventaDetails = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'flota_nombre',
        header: 'Técnico',
        // enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.flota_data?.nombre! || "N/A",
      },
      {
        accessorKey: 'user_create',
        header: 'Asesor Venta',
        enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          const dataAux = {
            user: row.original?.user_create!
          }
          if (dataAux) {
            return InfoUser(dataAux)
          } else {
            return "N/A"
          }
          // || 
        },
      },
      {
        accessorKey: 'canal_venta_data.nombre',
        header: 'Canal de Venta',
        enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.canal_venta_create || "N/A",
      },
      // {
      //   accessorKey: 'responsable_razon_social',
      //   header: 'Responsable',
      //   enableColumnFilter: false,
      //   size: 400,
      //   Cell: ({ row }) => row.original?.supervisor_data?.razon_social || row.original?.user_create_data?.razon_social || "N/A",
      // },
      {
        accessorKey: 'user_revisa_username',
        header: 'Revisado Por',
        // enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.user_revisa || "N/A",
      },

    ],
    []
  );

  const geolocationDetails = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      // {
      //   accessorKey: 'pais_nombre', // to allow filtering
      //   header: 'País',
      //   size: 200,
      //   Cell: ({ row }) =>
      //     row.original?.pais_data?.nombre || 'N/A',
      //     //row.original?.cliente_data?.pais_data?.nombre || 'N/A',
      // },
      {
        accessorKey: 'provincia_nombre',
        header: 'Provincia',
        size: 200,
        Cell: ({ row }) =>
          row.original?.provincia_data?.nombre || 'N/A',
        // row.original?.cliente_data?.provincia_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'ciudad_nombre',
        header: 'Ciudad',
        size: 200,
        Cell: ({ row }) =>
          row.original?.ciudad_data?.nombre || 'N/A',
        // row.original?.cliente_data?.ciudad_data?.nombre || 'N/A',
      },
      // {
      //   accessorKey: 'zona_nombre',
      //   header: 'Zona',
      //   size: 200,
      //   Cell: ({ row }) =>
      //     row.original?.zona_data?.nombre || 'N/A',
      //     // row.original?.cliente_data?.zona_data?.nombre || 'N/A',
      // },
      {
        accessorKey: 'sector_nombre',
        header: 'Sector',
        size: 200,
        Cell: ({ row }) =>
          row.original?.sector_data?.nombre || 'N/A',
        // row.original?.cliente_data?.sector_data?.nombre || 'N/A',
      },
    ],
    []
  );

  ///* tables -----------------------
  const clientesFibraColumns = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      ...base01,
      ...clientDetails,
      ...serviceDetails01,
      ...activacionDetails,
      ...ventaDetails,
      ...geolocationDetails,
    ],
    []
  );

  const clientesFibraColumnsFilterMotivos = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'Identificación',
        size: 60,
        Cell: ({ row }) =>
          row.original?.cliente_data?.identificacion ? (
            <>
              <CustomTableLink
                url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
                text={row.original?.cliente_data?.identificacion}
              />
            </>
          ) : (
            'N/A'
          ),
      },
      {
        accessorKey: 'razon_social',
        header: 'Nombre',
        size: 333,
        Cell: ({ row }) => {
          const calculatedName = calcLineaNameContrato(row?.original! || {});

          return row.original?.cliente_data?.razon_social ? (
            <CustomTableLink
              url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
              text={calculatedName}
            />
          ) : (
            'N/A'
          );
        },
      },


      // estado de información ------------------
      {
        accessorKey: 'estado_actualizacion',
        header: 'Estado Contrato',
        enableColumnFilter: false,
        size: 250,
        Cell: ({ row }) => {
          return <DataContractStateChip statusData={row.original?.estado_actualizacion!} />;
        },
      },


      // contrato ------------------
      {
        accessorKey: 'numero_referencia',
        header: 'Núm. Contrato',
        size: 90,
        Cell: ({ row }) => emptyCellOneLevel(row, 'numero_referencia'),
      },
      {
        accessorKey: 'url_contrato',
        header: 'CONTRATO',
        size: 90,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const url = row.original?.url_contrato;
          if (!url) return 'N/A';

          return (
            <SingleButton
              newCustomButton
              iconButton
              label="Ver contrato"
              color="error"
              startIcon={<PictureAsPdfIcon />}
              onClick={() => {
                window.open(url, '_blank');
              }}
            />
          );
        },
      },
      {
        accessorKey: 'vendedor',
        header: 'Vendedor',
        // enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.vendedor_data?.razon_social || "N/A",
      },
      {
        accessorKey: 'flota_nombre',
        header: 'Técnico',
        // enableColumnFilter: false,
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.flota_data?.nombre! || "N/A",
      },
      // responsable_razon_social
      // {
      //   accessorKey: 'responsable_razon_social',
      //   header: 'Supervisor',
      //   // enableColumnFilter: false,
      //   size: 400,
      //   Cell: ({ row }) => row.original?.supervisor_data?.razon_social || "N/A",
      // },
      // {
      //   accessorKey: 'departamento_data.nombre',
      //   header: 'Departamento',
      //   enableColumnFilter: false,
      //   size: 400,
      //   Cell: ({ row }) => row.original?.departamento_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: 'departamento_supervisor_data.nombre',
      //   header: 'Departamento Supervisor',
      //   enableColumnFilter: false,
      //   size: 400,
      //   Cell: ({ row }) => row.original?.departamento_supervisor_data?.nombre || "N/A",
      // },
      {
        accessorKey: 'canal_venta_create',
        header: 'Canal de Venta',
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.canal_venta_create || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato.ultimos_motivos_correccion',
        header: 'Último Motivo de Corrección',
        enableColumnFilter: false,
        size: 300,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length - 1]?.motivos?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato_tecnico',
        header: 'Última Observación Técnico',
        enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length - 1]?.observaciones_tecnico?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato_ventas',
        header: 'Última Observación Ventas',
        enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length - 1]?.observaciones_ventas?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato_fecha_ultima_correccion',
        header: 'Fecha Última Solicitud Corrección',
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const fechaAux = row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length - 1]?.fecha
          if (fechaAux) {
            return dayjs(fechaAux).format("LLL")
          }
          return "N/A"
        }
      },

      {
        accessorKey: 'provincia_nombre',
        header: 'Provincia',
        size: 200,
        Cell: ({ row }) =>
          row.original?.provincia_data?.nombre || 'N/A',
        // row.original?.cliente_data?.provincia_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'ciudad_nombre',
        header: 'Ciudad',
        size: 200,
        Cell: ({ row }) =>
          row.original?.ciudad_data?.nombre || 'N/A',
        // row.original?.cliente_data?.ciudad_data?.nombre || 'N/A',
      },

      // ...clientDetails,
      // ...serviceDetails01,
      // ...activacionDetails,
      // ...ventaDetails,
      // ...geolocationDetails,
    ],
    []
  );

  return {
    clientesFibraColumns,
    clientesFibraColumnsFilterMotivos
  };
};
